theme.RS = theme.RS || {};
theme.RS.helpers = (function() {
  const calculateElementToViewportBottom = function(element) {
    if (element) {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const offset = viewportHeight - rect.top - 15;
      return offset;
    }
  };

  const calculateTotalHeight = function calculateTotalHeight(element) {
    let totalHeight = null;
    if (element) {
      let style = window.getComputedStyle(element);
  
      let height = element.offsetHeight; // includes padding and border
      let marginTop = parseInt(style.marginTop || 0);
      let marginBottom = parseInt(style.marginBottom || 0);
  
      totalHeight = height + marginTop + marginBottom;
    }
    return totalHeight;
  }

  return {
    calculateElementToViewportBottom,
    calculateTotalHeight
  }
})();